/* The Rug District — Rug Size Guide sections (rsg-*) */
(function () {
  if (window.RSG) { window.RSG.initAll(); return; }

  var STORE_KEY = 'trd-rsg-unit';
  var root = document.documentElement;

  /* ---------- Units (feet / centimetres), shared by every section ---------- */
  function getUnit() {
    try { var u = localStorage.getItem(STORE_KEY); if (u === 'cm' || u === 'ft') return u; } catch (e) {}
    return root.getAttribute('data-rsg-default-unit') || 'ft';
  }
  function setUnit(u, save) {
    root.classList.toggle('rsg-unit-cm', u === 'cm');
    document.querySelectorAll('[data-rsg-unit]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-rsg-unit') === u));
    });
    if (save) { try { localStorage.setItem(STORE_KEY, u); } catch (e) {} }
  }
  function initUnits(scope) {
    var t = scope.querySelector('[data-rsg-default]');
    if (t) root.setAttribute('data-rsg-default-unit', t.getAttribute('data-rsg-default'));
    setUnit(getUnit(), false);
    scope.querySelectorAll('[data-rsg-unit]').forEach(function (b) {
      if (b._rsg) return; b._rsg = true;
      b.addEventListener('click', function () { setUnit(b.getAttribute('data-rsg-unit'), true); });
    });
  }

  /* ---------- Room tabs ---------- */
  function initRooms(sec) {
    var tabs = Array.prototype.slice.call(sec.querySelectorAll('[role="tab"]'));
    if (!tabs.length || sec._rsgRooms) return;
    sec._rsgRooms = true;
    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) tabs[i].focus();
    }
    sec._rsgSelect = select;
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') n = (i + 1) % tabs.length;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
        else if (k === 'Home') n = 0;
        else if (k === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); select(n, true); }
      });
    });
  }

  /* ---------- Sizes in real rooms slider ---------- */
  function initSlider(sec) {
    var stage = sec.querySelector('[data-rsg-stage]');
    if (!stage || sec._rsgSlider) return;
    var slides = Array.prototype.slice.call(stage.querySelectorAll('[data-rsg-slide]'));
    var infos = Array.prototype.slice.call(sec.querySelectorAll('[data-rsg-info]'));
    var dots = Array.prototype.slice.call(sec.querySelectorAll('[data-rsg-dot]'));
    var prog = stage.querySelector('[data-rsg-prog]');
    if (!slides.length) return;
    var s = {
      cur: 0, open: false, hover: false, elapsed: 0, last: 0,
      dur: (parseFloat(stage.getAttribute('data-rsg-interval')) || 6) * 1000,
      auto: stage.getAttribute('data-rsg-autoplay') === 'true' && slides.length > 1,
      alive: true
    };
    try { if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) s.auto = false; } catch (e) {}
    if (window.Shopify && Shopify.designMode) s.auto = false;
    sec._rsgSlider = s;

    function render() {
      slides.forEach(function (el, i) {
        var on = i === s.cur;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-hidden', String(!on));
        el.querySelectorAll('a, button').forEach(function (f) { f.tabIndex = on ? 0 : -1; });
        var pop = el.querySelector('[data-rsg-pop]'), hot = el.querySelector('[data-rsg-hot]');
        if (pop) pop.hidden = !(on && s.open);
        if (hot) hot.setAttribute('aria-expanded', String(on && s.open));
      });
      infos.forEach(function (el, i) { el.hidden = i !== s.cur; });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', String(i === s.cur)); });
      if (prog) prog.style.width = '0%';
    }
    function go(i) { s.cur = (i + slides.length) % slides.length; s.open = false; s.elapsed = 0; render(); }
    s.go = go;

    var prev = sec.querySelector('[data-rsg-prev]'), next = sec.querySelector('[data-rsg-next]');
    if (prev) prev.addEventListener('click', function () { go(s.cur - 1); });
    if (next) next.addEventListener('click', function () { go(s.cur + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });

    stage.addEventListener('click', function (e) {
      var hot = e.target.closest('[data-rsg-hot]');
      if (hot) {
        s.open = !s.open; render();
        if (s.open) { var a = slides[s.cur].querySelector('[data-rsg-pop] a'); if (a) a.focus(); }
      } else if (s.open && !e.target.closest('[data-rsg-pop]')) { s.open = false; render(); }
    });
    sec.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && s.open) {
        s.open = false; render();
        var h = slides[s.cur].querySelector('[data-rsg-hot]'); if (h) h.focus();
      } else if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && stage.contains(e.target)) {
        go(s.cur + (e.key === 'ArrowRight' ? 1 : -1));
      }
    });
    sec.addEventListener('mouseenter', function () { s.hover = true; });
    sec.addEventListener('mouseleave', function () { s.hover = false; });
    sec.addEventListener('focusin', function () { s.hover = true; });
    sec.addEventListener('focusout', function (e) { if (!sec.contains(e.relatedTarget)) s.hover = false; });

    var sx = null;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) go(s.cur + (dx < 0 ? 1 : -1));
      sx = null;
    });

    function tick(t) {
      if (!s.alive) return;
      var dt = s.last ? t - s.last : 0; s.last = t;
      if (s.auto && !s.hover && !s.open && !document.hidden) {
        s.elapsed += dt;
        if (s.elapsed >= s.dur) go(s.cur + 1);
        if (prog) prog.style.width = Math.min(100, s.elapsed / s.dur * 100) + '%';
      }
      requestAnimationFrame(tick);
    }
    if (prog && !s.auto) prog.parentNode.hidden = true;
    render();
    requestAnimationFrame(tick);
  }

  function initSection(sec) {
    initUnits(sec);
    if (sec.hasAttribute('data-rsg-rooms')) initRooms(sec);
    if (sec.hasAttribute('data-rsg-slider')) initSlider(sec);
  }
  function initAll() {
    setUnit(getUnit(), false);
    document.querySelectorAll('[data-rsg]').forEach(initSection);
  }

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-rsg]'); if (sec) initSection(sec);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var sec = e.target.querySelector('[data-rsg-slider]');
    if (sec && sec._rsgSlider) sec._rsgSlider.alive = false;
  });
  document.addEventListener('shopify:block:select', function (e) {
    var b = e.target;
    var sec = b.closest('[data-rsg]'); if (!sec) return;
    if (sec._rsgSelect) {
      var tab = b.matches('[role="tab"]') ? b : null;
      if (!tab && b.hasAttribute('data-rsg-room-of')) tab = sec.querySelector('[role="tab"][aria-controls="' + b.getAttribute('data-rsg-room-of') + '"]');
      if (tab) {
        var tabs = Array.prototype.slice.call(sec.querySelectorAll('[role="tab"]'));
        sec._rsgSelect(tabs.indexOf(tab), false);
      }
    }
    if (sec._rsgSlider && b.hasAttribute('data-rsg-slide')) {
      var slides = Array.prototype.slice.call(sec.querySelectorAll('[data-rsg-slide]'));
      sec._rsgSlider.go(slides.indexOf(b));
    }
  });

  window.RSG = { initAll: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
